import { WindowLevelTool } from "@cornerstonejs/tools";
import BrightnessMediumIcon from "@mui/icons-material/BrightnessMedium";

class ContrastTool extends WindowLevelTool {}
ContrastTool.toolName = "ContrastTool";

export { ContrastTool };

export const ContrastToolConfig = {
  name: "CONTRAST",
  tool: "ContrastTool",
  icon: <BrightnessMediumIcon />,
};